export const API_BASE_URL = "https://apimilkmor.techaastha.com";

// TO APPLY PERMISSIONS
export const API_GET_ROLE_PERMSSIONS_DATA = `${API_BASE_URL}/api/role-permission/login-permissions/`;
// export const API_GET_ROLES_ALL_PERMISSIONS = `${API_BASE_URL}/api/role-permission/login-permissions`;

//  Dashboard

export const API_DASHBOARD_GET_CARD_DATA = `${API_BASE_URL}/api/dashboard/cards-data/`;

// LOGIN API'S
export const API_LOGIN = `${API_BASE_URL}/api/login/`;
export const API_SEND_OTP = `${API_BASE_URL}/api/send-otp/`;
export const API_VERIFY_OTP = `${API_BASE_URL}/api/verify-otp/`;
export const API_FORGOT_PASSWORD = `${API_BASE_URL}/api/forgot-password/`;

// Scheduler Settings
export const API_DASHBOARD_SCHEDULAR_LIST_GET = `${API_BASE_URL}/api/dashboard/scheduler-list/`;
export const API_DASHBOARD_SCHEDULAR_RUN = `${API_BASE_URL}/api/dashboard/scheduler-run/`;
export const API_DASHBOARD_SCHEDULER_SEND_SMS = `${API_BASE_URL}/api/dashboard/send-hub-sms/`;
export const API_DASHBOARD_SCHEDULER_CONSTANTS_UPDATE = `${API_BASE_URL}/api/dashboard/milkmor-constants-update/`;
export const API_DASHBOARD_SCHEDULER_CONSTANTS_GET_ALL_DATA = `${API_BASE_URL}/api/dashboard/milkmor-constants-list/`;

// CITY API'S
export const API_CITY_GET_POST = `${API_BASE_URL}/api/city/`;
export const API_CITY_GE = `${API_BASE_URL}/api/get-city/`;
export const API_CITY_GET_BY_ID = `${API_BASE_URL}/api/get-city/`;
export const API_CITY_UPDATE = `${API_BASE_URL}/api/upgrade-city/`;
export const API_CITY_DELETE = `${API_BASE_URL}/api/delete-city/`;
export const API_CITY_DATE_UPDATE = `${API_BASE_URL}/api/dateupdate/`;

// PINCODE API'S
export const API_PINCODE_GET_POST = `${API_BASE_URL}/api/pincode/`;
export const API_PINCODE_GET_BY_ID = `${API_BASE_URL}/api/get-pincode/`;
export const API_PINCODE_UPDATE = `${API_BASE_URL}/api/upgrade-pincode/`;
export const API_PINCODE_DELETE = `${API_BASE_URL}/api/remove-pincode/`;
export const API_PINCODE_DATE_UPDATE = `${API_BASE_URL}/api/date-update/`;
export const API_PINCODE_LOG = `${API_BASE_URL}/api/log-pincode/`;

// AREA API'S
export const API_AREA_GET_POST = `${API_BASE_URL}/api/area/`;
export const API_AREA_GET_BY_ID = `${API_BASE_URL}/api/get-area/`;
export const API_AREA_UPDATE = `${API_BASE_URL}/api/upgrade-area/`;
export const API_AREA_DATE_UPDATE = `${API_BASE_URL}/api/area-date-update/`;

// CUSTOMER_GROUP API'S
export const API_CUSTOMER_GROUP_GET_POST = `${API_BASE_URL}/api/customer-group/`;
export const API_CUSTOMER_GROUP_GET_BY_ID = `${API_BASE_URL}/api/get-customer-group/`;
export const API_CUSTOMER_GROUP_UPDATE = `${API_BASE_URL}/api/upgrade-customer-group/`;
export const API_CUSTOMER_GROUP_DELETE = `${API_BASE_URL}/api/remove-customer-group/`;
export const API_CUSTOMER_BOTTLE_MANAGEMENT_DAILY_BOTTLE = `${API_BASE_URL}/api/bottle-management-history/`;
export const API_CUSTOMER_BOTTLE_MANAGEMENT_CUSTOMER_WISE_BOTTLE = `${API_BASE_URL}/api/customer-wise-bottle-management/`;

// PRODUCT_CATEGORY API'S
export const API_PRODUCT_CATEGORY_GET_POST = `${API_BASE_URL}/api/product-category/`;
export const API_PRODUCT_CATEGORY_GET_BY_ID = `${API_BASE_URL}/api/get-product-category/`;
export const API_PRODUCT_CATEGORY_UPDATE = `${API_BASE_URL}/api/upgrade-product-category/`;
export const API_PRODUCT_CATEGORY_DELETE = `${API_BASE_URL}/api/remove-product-category/`;

// UOM API'S
export const API_UOM_GET_POST = `${API_BASE_URL}/api/uom/`;
export const API_UOM_GET_BY_ID = `${API_BASE_URL}/api/get-uom/`;
export const API_UOM_UPDATE = `${API_BASE_URL}/api/upgrade-uom/`;
export const API_UOM_DELETE = `${API_BASE_URL}/api/remove-uom/`;

// TAX_RATE API'S
export const API_TAX_RATE_GET_POST = `${API_BASE_URL}/api/tax-rate/`;
export const API_TAX_RATE_GET_BY_ID = `${API_BASE_URL}/api/get-tax-rate/`;
export const API_TAX_RATE_UPDATE = `${API_BASE_URL}/api/upgrade-tax-rate/`;
export const API_TAX_RATE_DELETE = `${API_BASE_URL}/api/remove-tax-rate/`;

// DELIVERY_PATTERN API'S
export const API_DELIVERY_PATTERN_GET_POST = `${API_BASE_URL}/api/delivery-partner/`;
export const API_DELIVERY_PATTERN_GET_BY_ID = `${API_BASE_URL}/api/get-delivery-partner/`;
export const API_DELIVERY_PATTERN_UPDATE = `${API_BASE_URL}/api/upgrade-delivery-partner/`;
export const API_DELIVERY_PATTERN_DELETE = `${API_BASE_URL}/api/remove-delivery-pattern/`;

// HSN_CODE API'S
export const API_HSN_CODE_GET_POST = `${API_BASE_URL}/api/hsn-code/`;
export const API_HSN_CODE_GET_BY_ID = `${API_BASE_URL}/api/get-hsn-code/view/`;
export const API_HSN_CODE_UPDATE = `${API_BASE_URL}/api/upgrade-hsn-code/`;
export const API_HSN_CODE_DELETE = `${API_BASE_URL}/api/remove-hsn-code/`;

// ROLE_AND_PERMISSION
export const API_RESOURCES_GET = `${API_BASE_URL}/api/get-resource/`;
export const API_ROLE_AND_PERMISSION_GET_POST = `${API_BASE_URL}/api/add-role-permission/`;
export const API_ROLE_AND_PERMISSION_DELETE = `${API_BASE_URL}/api/remove-role-permission/`;
export const API_ROLE_AND_PERMISSION_GET_BY_ID = `${API_BASE_URL}/api/view-role-permission/`;
export const API_ROLE_AND_PERMISSION_UPDATE = `${API_BASE_URL}/api/upgrade-role-permission/`;
// export const API_HSN_CODE_UPDATE = `${API_BASE_URL}/api/upgrade-hsn-code/`;

// DEPARTMENT TYPE
export const API_DEPARTMENT_TYPE_GET_POST = `${API_BASE_URL}/api/add-department-type/`;
export const API_DEPARTMENT_TYPE_DELETE = `${API_BASE_URL}/api/remove-department-type/`;
export const API_DEPARTMENT_TYPE_VIEW_BY_ID = `${API_BASE_URL}/api/view-department-type/`;
export const API_DEPARTMENT_TYPE_UPDATE = `${API_BASE_URL}/api/upgrade-department-type/`;

// FARM
export const API_FARM_GET_POST = `${API_BASE_URL}/api/farm/farm-list/`;
export const API_FARM_UPDATE = `${API_BASE_URL}/api/farm/upgrade-farm-list/`;
export const API_FARM_VIEW_BY_ID = `${API_BASE_URL}/api/farm/upgrade-farm-list/`;

// CWh
export const API_CWH_GET_POST = `${API_BASE_URL}/api/central-warehouse/create/`;
export const API_CWH_UPDATE = `${API_BASE_URL}/api/central-warehouse/upgrade/`;
export const API_CWH_VIWE_BY_ID = `${API_BASE_URL}/api/central-warehouse/view/`;

// USERS
export const API_USER_POST_GET = `${API_BASE_URL}/api/users/`;
export const API_USER_GETBY_ID_AND_UPDATE = `${API_BASE_URL}/api/upgrade-users/`;
export const API_DESIGNATION_POST_GET = `${API_BASE_URL}/api/designation/`;

// DELIVERY BOYS
export const API_DELIVERY_BOYS_POST_GET = `${API_BASE_URL}/api/delivery-boy/`;
export const API_DELIVERY_BOYS_GET_BY_ID_AND_UPDATE = `${API_BASE_URL}/api/upgrade-delivery-boy/`;
export const API_DELIVERY_BOYS_AREA_WISE_DELIVERY = `${API_BASE_URL}/api/order/areawise-deliveries/`;
export const API_DELIVERY_BOYS_DELIVERY_ORDERS = `${API_BASE_URL}/api/hub/delivery-boy-log-details/`;

// Product
export const API_PRODUCT_POST_GET = `${API_BASE_URL}/api/product/`;
export const API_PRODUCT_VIEW_BY_ID_AND_UPDATE = `${API_BASE_URL}/api/product/upgrade-product-list/`;

// OFFERS
export const API_OFFERS_POST_GET = `${API_BASE_URL}/api/offers/`;
export const API_OFFERS_CANCEL = `${API_BASE_URL}/api/offers/delete-offers-list/`;

// Tickets
export const API_TICKETS_GET = `${API_BASE_URL}/api/ticket/`;
export const API_TICKETS_RESOLVE = `${API_BASE_URL}/api/update-status/`;

// COMPANY DETAILS
export const API_COMPANY_DETAILS_POST_GET = `${API_BASE_URL}/api/company-details/`;
export const API_COMPANY_DETAILS_VIEW_BY_ID_AND_UPDATE = `${API_BASE_URL}/api/upgrade-company-details/`;

// HTML SECTION
export const API_HTML_SECTION_GET = `${API_BASE_URL}/api/html-section/`;
export const API_HTML_SECTION_GET_BT_ID_AND_UPDATE = `${API_BASE_URL}/api/upgrade-html-section/`;

// TERMS & CONDITIONS
export const API_TERMS_AND_CONDITIONS_GET = `${API_BASE_URL}/api/terms-conditions/`;
export const API_TERMS_AND_CONDITIONS_UPDATE = `${API_BASE_URL}/api/upgrade-terms-conditions/`;

// HUB
export const API_HUB_ADD_GET = `${API_BASE_URL}/api/hub/hub-list/`;
export const API_HUB_GET_BY_ID_AND_UPDATE = `${API_BASE_URL}/api/upgrade-hub/`;
export const API_HUB_GET_BY_ID_AND_UPDATE_NEW = `${API_BASE_URL}/api/hub/hub-details/`;
export const API_HUB_GET_UNASSIGNED_PINCODES = `${API_BASE_URL}/api/hub/unassigned-pincodes/?city_id=`;
export const API_HUB_GET_UNASSIGNED_DELIVERY_BOYS = `${API_BASE_URL}/api/hub/unassigned-delivery-boys/`;

export const API_HUB_WISE_ALLOCATED_DELIVERIES = `${API_BASE_URL}/api/hub/allocated-deliveries/?hub_id=`;
export const API_HUB_WISE_DELIVERYBOY_DELIVERIES_GET = `${API_BASE_URL}/api/hub/delivery-order-log/`;
//
export const API_HUB_TRANSFER_DELIVERY_TO_OTHER_DELIVERY_BOY = `${API_BASE_URL}/api/hub/transfer-deliveries/`;
export const API_HUB_ALLOCATE_HUB = `${API_BASE_URL}/api/order/allocate-hub/ `;
export const API_HUB_CANCEL_SUBSCRIPTION_ORDER = `${API_BASE_URL}/api/order/cancel-subscription-order/`;
export const API_HUB_MANAGE_TASK_GET = `${API_BASE_URL}/api/hub/hub-tasks/`;
export const API_HUB_MANAGE_TASK_GET_BY_TASK_NO = `${API_BASE_URL}/api/hub/assign-task/?task_id=`;
export const API_HUB_PAUSE_SUBSCRIPTION_ORDER = `${API_BASE_URL}/api/order/pause-subscription-order/`;
export const API_HUB_CHANGE_ORDER_STATUS = `${API_BASE_URL}/api/order/change-order-status/`;
export const API_HUB_NEW_USER_VERIFY = `${API_BASE_URL}/api/order/create-hub-task/`;
export const API_HUB_MANAGE_TASK_GET_BY_HUB = `${API_BASE_URL}/api/hub/hub-tasks/?hub_id=`;
export const API_HUB_MANAGE_TASK_TASK_ASSIGN = `${API_BASE_URL}/api/hub/assign-task/?task_id=`;
export const API_HUB_MANAGE_TASK_TASK_UNASSIGN = `${API_BASE_URL}/api/unassign-task/`;

// HUB
//   Delivery logs
export const API_HUB_DELIVERY_LOGS_GET = `${API_BASE_URL}/api/hub/delivery-log-list/?date=`;
export const API_HUB_DELIVERYBOY_END_DAY = `${API_BASE_URL}/api/hub/delivery-log-complete/`;
export const API_HUB_DELIVERYBOY_OR_DELIVERY_ASSISTANT_GET = `${API_BASE_URL}/api/hub/delivery-boy-log-details/`;
// api/hub/delivery-boy-log-details/?delivery_boy_id=073a1393-abf0-43a0-8b85-0e652c204cd8&date=2023-11-27

// hub
//  Collection Summary
export const API_HUB_COLLECTION_SUMMARY = `${API_BASE_URL}/api/hub/collection-summary-list/`;
export const API_HUB_COLLECTION_SUMMARY_WITH_FILTER = `${API_BASE_URL}/api/accounts/collection-summary/`;

// Inventory
// Indent
export const API_INDENT_CREATE_GET_POST = `${API_BASE_URL}/api/inventory/indent/`;
export const API_INDENT_GET_LIST_OF_INDENT = `${API_BASE_URL}/api/inventory/indent-list/`;
export const API_INDENT_GET_BY_ID = `${API_BASE_URL}/api/inventory/id-get/`;
export const API_INDENT_DISPATCH_DETAILS_GET_POST = `${API_BASE_URL}/api/inventory/dispatch-details/ `;
export const API_INDENT_STATUS_APPROVE_OR_REJECT = `${API_BASE_URL}/api/inventory/update-status/`;
export const API_INDENT_TO_CREATE_OUTWARD = `${API_BASE_URL}/api/inventory/outward/`;
export const API_INDENT_CREATE_INWARD = `${API_BASE_URL}/api/inventory/receive-inward/`;

// INWARD
export const API_INDENT_INWARD_GET = `${API_BASE_URL}/api/inventory/inward/`;
export const API_INDENT_INWARD_GET_NEW = `${API_BASE_URL}/api/inventory/inward-list/`;

// OUTWARD
export const API_INDENT_OUTARD_GET_DATA = `${API_BASE_URL}/api/inventory/outward/`;
export const API_INDENT_OUTARD_GET_DATA_NEW = `${API_BASE_URL}/api/inventory/outward-list/`;
export const API_INDENT_OUTARD_GET_DATA_BY_ID = `${API_BASE_URL}/api/inventory/outward-id-get/`;

// Stock
export const API_STOCK_GET_POST = `${API_BASE_URL}/api/inventory/stock/`;
export const API_STOCK_GET_NEW = `${API_BASE_URL}/api/inventory/stock-list/`;

// Retuen Stock
export const API_RETURN_STOCK_CREATE_INITIAL_DATA_GET_AND_POST = `${API_BASE_URL}/api/inventory/return-outward/`;
export const API_RETURN_STOCK_GET_DATA = `${API_BASE_URL}/api/inventory/return-outward-list/`;

//  Stock Transferred
export const API_STOCK_TRANSFERRED_GET_DATA = `${API_BASE_URL}/api/inventory/stock-transfered/`;
export const API_STOCK_TRANSFERRED_GET_DATA_FOR_TABLE_LIST = `${API_BASE_URL}/api/inventory/stock-transfered-list/`;

// Stock Summary

export const API_STATUS_WISE_STOCK_SUMMARY_FOR_CWH = `${API_BASE_URL}/api/inventory/stock-summary/warehouse-statuswise/`;
export const API_BATCH_WISE_STOCK_SUMMARY = `${API_BASE_URL}/api/inventory/stock-summary/`;

// Customers
// customer list
export const API_CUSTOMERS_REGISTER_GET_POST = `${API_BASE_URL}/api/VerifyCustomerOTP/`;
export const API_CUSTOMERS_GET_BY_ID = `${API_BASE_URL}/api/CustomerGetID/`;
export const API_CUSTOMERS_STATUS_AND_SUMMARY = `${API_BASE_URL}/api/customer-status-summary/`;
export const API_CUSTOMERS_UPDATE = `${API_BASE_URL}/api/CustomerUpdate/`;
export const API_CUSTOMERS_GET_LIST = `${API_BASE_URL}/api/customers-list/`;
export const API_CUSTOMERS_REGISTER = `${API_BASE_URL}/api/customer/add/`;

// Accounts
export const API_ACCOUNT_GET = `${API_BASE_URL}/api/accounts/invoice/`;
export const API_ACCOUNT_GET_BY_ORDER_NO = `${API_BASE_URL}/api/accounts/invoice-details/`;

// Subscription
//  Trial Plan
export const API_TRIAL_PLAN_GET_BY_ID_AND_UPDATE = `${API_BASE_URL}/api/subscription/trial-plan/`;
export const API_TRIAL_PLAN_AND_SUBSCRIPTION_GET = `${API_BASE_URL}/api/subscription/subscription-plan-view/`;
export const API_TRIAL_PLAN_UPDATE = `${API_BASE_URL}/api/subscription/trial-plan/`;
export const API_SUBSCRIPTION_UPDATE = `${API_BASE_URL}/api/upgrade-subscription/`;
export const API_DELIVERY_FREQUENCY_GET = `${API_BASE_URL}/api/delivery-frequency-view/`;
export const API_DELIVERY_FREQUENCY_UPDATE = `${API_BASE_URL}/api/upgrade-delivery-frequency/`;
export const API_CUSTOMER_SUBSCRIPTION_PLAN_VIEW = `${API_BASE_URL}/api/subscription/customer-subscription-plan-view/`;

export const API_SUBSCRIPTION_ORDER_ADD = `${API_BASE_URL}/api/order/create-order/`;
export const API_SUBSCRIPTION_ORDER_DATA_GET = `${API_BASE_URL}/api/order/orders-list/`;
export const API_SUBSCRIPTION_ORDER_DATA_GET_BY_ID = `${API_BASE_URL}/api/order/order-details/`;
export const API_SUBSCRIPTION_ORDER_STATUS_DATA_GET_BY_ID = `${API_BASE_URL}/api/order/order-status/?order_id=`;
export const API_SUBSCRIPTION_OFFER_APPLY = `${API_BASE_URL}/api/order/apply-offer/`;
export const API_SUBSCRIPTION_ALLOCATE_DELIVERY_BOY = `${API_BASE_URL}/api/order/allocate-delivery-boy/`;
export const API_SUBSCRIPTION_ORDER_CONINUE_WITH_SAME_ORDER = `${API_BASE_URL}/api/order/renew-same-order-offline/`;
export const API_SUBSCRIPTION_ORDER_CANCEL_GET = `${API_BASE_URL}/api/subscription-cancel-request-list/`;
export const API_SUBSCRIPTION_REQUEST_TO_CANCEL_GET_PUT = `${API_BASE_URL}/api/order/subscription-cancel-request-update/`;
export const API_SUBSCRIPTION_EXCEL_DOWNLOAD = `${API_BASE_URL}/api/order/export-subscription-orders/?status=`;

// Cart Orders
export const API_CART_ORDER_GET = `${API_BASE_URL}/api/order/cart-orders-list/`;
export const API_CART_ORDER_GET_STOCK_FOR_ASSIGN_ORDER = `${API_BASE_URL}/api/order/cart-order-assign/`;
export const API_CART_ORDER_GET_BY_ID = `${API_BASE_URL}/api/order/cart-order-details/`;
export const API_CART_ORDER_CANCEL = `${API_BASE_URL}/api/order/cart-order-cancel/`;
export const API_CART_ORDER_REFUND = `${API_BASE_URL}/api/order/refund-update/`;
export const API_CART_ORDER_ASSIGN_ORDER_DELIVERY_ASSISTANT_GET_PUT = `${API_BASE_URL}/api/order/cart-order-assign/`;
export const API_CART_ORDER_STATUS = `${API_BASE_URL}/api/order/order-status/?order_id=`;
export const API_CART_ORDER_SALE_REPORT = `${API_BASE_URL}/api/order/cart-orders-sales-report/`;
export const API_CART_ORDER_EXPORT_CART_ORDERS = `${API_BASE_URL}/api/order/export-cart-orders/`;
export const API_CART_ORDER_DELIVER_POST = `${API_BASE_URL}/api/order/cart-order-delivered/`;
export const API_CART_ORDER_ATTEMPTED = `${API_BASE_URL}/api/order/cart-order-attempted/`;

// Ecommerce Register
export const API_CUSTOMER_SIGN_UP_OPT = `${API_BASE_URL}/api/CustomerSendOtp/ `;
export const API_CUSTOMER_SIGN_UP_OTP_SUBMIT = `${API_BASE_URL}/api/VerifyCustomerOTP/ `;
export const API_CUSTOMER_LOG_IN_OTP = `${API_BASE_URL}/api/LoginGenerateOtp/`;
export const API_CUSTOMER_LOGIN_SUBMIT = `${API_BASE_URL}/api/CustomerLogin/ `;
export const API_CUSTOMER_REGISTER = `${API_BASE_URL}/api/customer/add/


`;

//Forgot Password Ecommerece
export const API_CUSTOMER_FORGOT_PASSWORD_OTP = `${API_BASE_URL}/api/ForgotPasswordOtp/`;
export const API_CUSTOMER_FORGOT_PASSWORD_OTP_VERIFICATION = `${API_BASE_URL}/api/ForgotOTP/`;
export const API_CUSTOMER_FORGOT_PASSWORD_FINAL_SUBMIT = `${API_BASE_URL}/api/ForgotPassword/`;

// HUB
export const API_HUB_DELIVERY_LOGS_RETURN_STOCK_GET_POST = `${API_BASE_URL}/api/hub/delivery-boy-return-stock/`;

//Ecommer Get User by Id
export const API_USER_GET_BY_ID = `${API_BASE_URL}/api/CustomerGetID/`;

//Ecommerce Add Items To Cart
export const API_ADD_ITEMS_TO_CART = `${API_BASE_URL}/api/order/subscription-cart/`;

//Ecommerce Update delivery frequency
export const UPDATE_ECOMMERCE_DELIVERY_FREQUENCY = `${API_BASE_URL}/api/order/update-delivery-frequency/`;

//Ecommerce Update subscription plan
export const UPDATE_ECOMMERCE_SUBSCRIPTION_PLAN = `${API_BASE_URL}/api/order/update-subscription-plan/`;

//Ecommerce Update delivery pattern
export const UPDATE_ECOMMERCE_DELIVERY_PATTERN = `${API_BASE_URL}/api/order/update-delivery-pattern/`;

//Ecommerce Get User Wallet
export const GET_ECOMMERCE_WALLET_DETAILS = `${API_BASE_URL}/api/customer-wallet-details/`;

//Ecommerce Get Customer Address By Id
export const GET_ECOMMERCE_CUSTOMER_ADDRESS = `${API_BASE_URL}/api/get-customer-address/`;

//Ecommerce Update Primary Address
export const CUSTOMER_ADDRESS_UPDATE_ECOMMERCE = `${API_BASE_URL}/api/customer-primary-address-update/`;

//Ecommerce Blocked Balance Transactions
export const ECOMMERCE_CUSTOMER_BLOCKED_TRANSACTIONS = `${API_BASE_URL}/api/customer-wallet-order-transactions/?customer_id=`;

//Ecommerce Blocked Balance Transactions Details
export const ECOMMERCE_CUSTOMER_BLOCKED_TRANSACTION_DETAILS = `${API_BASE_URL}/api/customer-wallet-order-transactions-details/?transaction_id=`;

//Ecommerce Customer Cart Order List
export const ECOMMERCE_CUSTOMER_CART_ORDER_LIST = `${API_BASE_URL}/api/order/customer-cart-orders-list/?page=`;

//Ecommerce Customer Subscription Order Logs
export const GET_ECOMMERCE_CUSTOMER_SUBSCRIPTION_ORDER_LOGS = `${API_BASE_URL}/api/order/customer-subscription-order-logs/`;

//Update Ecommerce Customer Subscription Order Logs
export const UPDATE_ECOMMERCE_CUSTOMER_SUBSCRIPTION_ORDER_LOGS = `${API_BASE_URL}/api/order/customer-subscription-order-log-update/`;

//Get Ecommerce Tickets By Id
export const GET_ECOMMERCE_TICKETS_BY_ID = `${API_BASE_URL}/api/get-ticket/`;

//Update Customer Mobile Number
export const UPDATE_ECOMMERCE_MOBILE_NUMBER = `${API_BASE_URL}/api/CustomerMobileUpdate/`;

//ECOMMERCE VERIFY UPDATE OTP
export const VERIFY_UPDATE_OTP = `${API_BASE_URL}/api/VerifyUpdateOtp/`;

//ECOMMERCE SUBSCRIPTION ORDER LIST
export const SUBSCRIPTION_ORDER_LIST = `${API_BASE_URL}/api/order/customer-sub-orders-list/?page=`;

//ECOMMERCE GET BOTTLE MANAGEMENT DATA
export const GET_BOTTLE_MANAGEMENT_DATA = `${API_BASE_URL}/api/customer-bottle-management/`;

//ECOMMERCE CANCEL SUBSCRIPTION ORDER REQUEST
export const CANCEL_ECOMMERCE_SUBSCRIPTION_ORDER_REQUEST = `${API_BASE_URL}/api/order/subscription-cancel-request/`;

//ECOMMERCE WALLET TRANSACTIONS BY CUSTOMER
export const CUSTOMER_WALLET_TRANSACTIONS = `${API_BASE_URL}/api/customer-wallet-transactions/?customer_id=`;

//DASHBOARD GET OUTWARD
export const GET_OUTWARD_DATA = `${API_BASE_URL}/api/inventory/outward/`;

//DASHBOARD GET OUTWARD BY ID
export const GET_OUTWARD_DATA_BY_ID = `${API_BASE_URL}/api/inventory/outward-id-get/`;

//DASHBOARD GET COLLECTION SUMMARY
export const GET_COLLECTION_SUMARY = `${API_BASE_URL}/api/accounts/collection-summary/?date=`;

//DASHBOARD GET PAYMENT TRANSACTIONS
export const GET_PAYMENT_DATA = `${API_BASE_URL}/api/accounts/payment-transactions/?page=`;

//DASHBOARD POST PAYMENT TRANSACTION REFERENCE
export const POST_PAYMENT_TRANSACTIONS_REFERENCE = `${API_BASE_URL}/api/accounts/payment-transactions-reference/`;

//DASHBOARD GET PENDING TRANSACTIONS DATA
export const GET_PENDING_TRANSACTIONS_DATA = `${API_BASE_URL}/api/accounts/pending-transactions/`;

//DASHBOARD WALLET LIST DATA
export const GET_DASHBOARD_WALLET_LIST_DATA = `${API_BASE_URL}/api/customer-wallet-list/`;

//OrderList Dropdown
export const GET_ORDER_LIST_FOR_DROPDOWN = `${API_BASE_URL}/api/order/orders-dropdown-list/`;

//Create Hub Task from Header
export const POST_HUB_TASK_FROM_HEADER = `${API_BASE_URL}/api/hub/create-hub-other-task/`;

//Cancel Hub Task from Header
export const CANCEL_HUB_TASK_FROM_HEADER = `${API_BASE_URL}/api/hub/task-cancel/`;

//View If Stock is Allocated to delivery boy / delivery assistant
export const VIEW_IF_STOCK_ALLOCATED_TO_DELIVERY_BOY = `${API_BASE_URL}/api/hub/delivery-boy-stock-view/`;

//Get Data to Allocate Data to Delivery Boy
export const GET_DATA_TO_ALLOCATE_STOCK = `${API_BASE_URL}/api/hub/allocate-stock-to-delivery-boy/`;

//Get Batch While Editing Delivery Quantity
export const GET_BATCH_DATA_WHILE_EDIT_DELIVERED_QUANTITY = `${API_BASE_URL}/api/hub/register-stock-batch/`;
